import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Opera = () => {
  const data = useStaticQuery(graphql`
    query {
      opera: file(relativePath: { eq: "opera.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img className="install-icon" fluid={data.opera.childImageSharp.fluid} />
  )
}

export default Opera
